








import {Component, Prop, Vue} from 'vue-property-decorator';
import lozad from 'lozad';

@Component
export default class LazyImage extends Vue {
  loading = false;

  @Prop({default: '#fff'}) backgroundColor!: string;
  @Prop({default: null}) height!: number;
  @Prop({default: null}) lazySrc!: string;
  @Prop({default: null}) lazySrcset!: string;
  @Prop({default: null}) width!: number;

  get aspectRatio(): number | null {
    if (!this.width || !this.height) return null;

    return (this.height / this.width) * 100;
  }

  get style(): object {
    return {
      backgroundColor: this.backgroundColor,
      width: `${this.width}px`,
      paddingTop: `${this.aspectRatio}%`
    };
  }


  mounted() {
    const setLoadingState = () => {
      this.loading = false;
    };
    this.$el.addEventListener('load', setLoadingState);
    this.$once('hook:destroyed', () => {
      this.$el.removeEventListener('load', setLoadingState);
    });

    const observer = lozad(this.$el);
    observer.observe();
  }

}
